//--------------
// get bleeders
//--------------
export default function getBleeders(combatants) {
  //------------------------------------------
  // get active combatants where bleeding > 0
  //------------------------------------------
  let bleeders = combatants.filter((a) => a.status == 'Active' && a.bleeding > 0)
  return bleeders
}
